import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import type { TabModel, Layout, Partial, LinkModel } from '@flocasts/experience-service-types'

/**
 * Date Bar component. [Figma link]{@link https://www.figma.com/file/eIZhWoF7WVmuRENkFymTZg/Results-Index?node-id=530%3A67069}
 *
 * The Date Bar can show a list of any string, intended for day or month to aid in
 * filtering. Seven are shown on desktop and tablet, 3 on mobile.
 */
@Component({
  selector: 'flo-date-bar',
  templateUrl: './date-bar.component.html',
  styleUrls: ['./date-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateBarComponent {
  /**
   * Array of dates, months, or any item. It should have a length of 7. The 1st,
   * 2nd, 2nd to last, and last items will hide on mobile.
   */
  @Input()
  public readonly items: ReadonlyArray<TabModel<Layout | Partial | null> | LinkModel>

  /**
   * TrackBy for items loop in template
   */
  readonly trackById = trackById
}
